module.exports = __webpack_public_path__ + "img/pt-PT-add-to-google-wallet.f352fa6.svg";